import webApi, { baseURL } from "../../WebApi/WebApi";

export const getInvoiceBusinessUnitList = async (data) => {
  return await webApi.get(`/customer/invoice/list-business-unit`, {});
};

export const getInvoiceSupplierList = async (data) => {
  return await webApi.get(`/customer/invoice/list-suppliers`, {});
};

//invoice listing
export const getAllInvoiceDetailslist = async (
  data,
  business,
  supplier,
  from,
  to
) => {
  console.log(data, business, supplier, from, to, "sdsdsd");
  return await webApi.post(
    `/customer/invoice/list-invoice?searchKeyword=${data}`,
    {
      businessUnitName: business ? business : [],
      suppliersName: supplier ? supplier : [],
      fromDate: from ? from : "",
      toDate: to ? to : "",
    }
  );
};

export const getInvoiceById = async (data) => {
  console.log(data, "datata");
  return await webApi.post(`/customer/invoice/get-invoice-by-id`, {
    invoiceId: Number(data),
  });
};

//create past order
export const getCreatePastOrder = async (invoiceIds, onSuccess, onFailure) => {
  console.log(invoiceIds, "invoiceIds");

  try {
    const res = await webApi.post(`/customer/past-order/add-past-order`, {
      invoiceIds: invoiceIds,
    });
    if (res.status === 200) {
      const r = res.data;
      return onSuccess(r);
    } else {
      onFailure("Something Wrong! Please Try again later" + res.data);
    }
  } catch (error) {
    console.log("fdgdf");
  }
};

export const getActiveInvoice = async (
  module,
  id,
  isactive,
  onSuccess,
  onFailure
) => {
  try {
    const res = await webApi.post(`/customer/common/is-active`, {
      module: module,
      id: id,
      isActive: isactive,
    });
    if (res.status === 200) {
      const r = res.data;
      return onSuccess(r);
    } else {
      onFailure("Something Wrong! Please Try again later" + res.data);
    }
  } catch (error) {
    console.log("fdgdf");
  }
};
